import type { SVGProps } from 'react';

export const SvgIconCategory120 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.125 17.5781V26.1281C6.125 26.3933 6.23036 26.6477 6.41789 26.8352C6.60543 27.0228 6.85978 27.1281 7.125 27.1281H25.125C25.3902 27.1281 25.6446 27.0228 25.8321 26.8352C26.0196 26.6477 26.125 26.3933 26.125 26.1281V17.5781"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.875 5.125H25.375C25.5919 5.12679 25.8026 5.1982 25.9758 5.32873C26.1491 5.45925 26.2759 5.64198 26.3375 5.85L28.125 12.125H4.125L5.9125 5.85C5.97409 5.64198 6.10087 5.45925 6.27416 5.32873C6.44744 5.1982 6.65806 5.12679 6.875 5.125V5.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.125 12.125V14.125C12.125 15.1859 11.7036 16.2033 10.9534 16.9534C10.2033 17.7036 9.18587 18.125 8.125 18.125C7.06413 18.125 6.04672 17.7036 5.29657 16.9534C4.54643 16.2033 4.125 15.1859 4.125 14.125V12.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.125 12.125V14.125C20.125 15.1859 19.7036 16.2033 18.9534 16.9534C18.2033 17.7036 17.1859 18.125 16.125 18.125C15.0641 18.125 14.0467 17.7036 13.2966 16.9534C12.5464 16.2033 12.125 15.1859 12.125 14.125V12.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.125 12.125V14.125C28.125 15.1859 27.7036 16.2033 26.9534 16.9534C26.2033 17.7036 25.1859 18.125 24.125 18.125C23.0641 18.125 22.0467 17.7036 21.2966 16.9534C20.5464 16.2033 20.125 15.1859 20.125 14.125V12.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
